// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"Z0-z"};